import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cute%20children%20playroom%20with%20soft%20natural%20light%2C%20colorful%20toys%2C%20wooden%20floor%2C%20cream%20walls%2C%20cozy%20atmosphere%2C%20minimalist%20Scandinavian%20style%20interior%20with%20plants%20and%20books%2C%20wide%20angle%20photography&width=1800&height=800&seq=hero-bg-2026&orientation=landscape"
        alt="悠宝三岁 - 专为3岁宝宝打造的成长方案"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      <div className="relative z-10 text-center px-4 md:px-6 w-full max-w-3xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <i className="ri-sparkling-2-fill text-secondary-300 text-xs"></i>
          <span className="text-background-50 text-xs md:text-sm font-medium">超过10万家庭的共同选择</span>
        </div>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
          陪宝宝度过
          <br />
          最<strong className="text-primary-300">重要</strong>的3岁
        </h1>
        <p className="text-background-50/90 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          悠宝三岁——专为3岁儿童设计的综合成长方案。科学早教、均衡营养、习惯培养，一站式陪伴宝宝度过关键发育阶段。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            探索成长方案
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-medium hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
          >
            了解悠宝三岁
          </Link>
        </div>
      </div>
    </section>
  );
}